<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="closeLeadForm">
            <v-card>
                <v-card-title class="justify-center">Close lead</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Lead</v-col> 
                    <v-col cols=10>{{ lead.pten_code }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5" v-if="lead.pten_bedrijfsnaam!==''">
                    <v-col cols=2>Company</v-col> 
                    <v-col cols=10>{{ lead.pten_bedrijfsnaam }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Name</v-col> 
                    <v-col cols=10>{{ lead.pten_voornaam }} {{ lead.pten_naam }}</v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-2">
                    <v-col cols=12>
                        <h4>All open lead actions will beset to closed, result set to:</h4>
                        <v-textarea v-model="actionResult" label="Action result" class="mt-5" rows="3" dense></v-textarea>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-5 mt-0">
                    <v-col cols=12>
                        <h4>Optional note to add to lead</h4>
                        <v-textarea v-model="ptenNote" label="Lead info note" class="mt-5" rows="3" dense></v-textarea>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-5">
                    <v-col cols=4></v-col>
                    <v-col cols=4>
                        <v-select v-model="leadStatus" :items="statList" item-value="ptst_code" item-text="ptst_oms" label="Set new status" clearable dense></v-select>
                    </v-col>
                    <v-col cols=4></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="closeLead">Save & Close</v-btn>
                    <v-btn color="primary" small @click="closeDialog">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                lead: {},
                statList: [],
                leadStatus: "",
                actionResult: "",
                ptenNote: "",
            }
        },
        methods: { 
            openDialog(lead, statList) {
                this.lead = lead;
                this.statList = statList;
                this.leadStatus = "";
                this.actionResult = "Action automatically closed when lead was set to closed.";
                this.ptenNote = "";
                this.dialog = true;
            },
            closeLead() {
                if (this.leadStatus === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "No closed status selected!",
                        color: "warning",
                    }); 
                    return
                }
                this.$axios.post("ares/json/ares/pten/setPtenStatus.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenStatus",
                    },
                    setPtenStatus: {
                        pten_encrid: this.lead.pten_encrid,
                        ptst_code: this.leadStatus,
                        actionResult: this.actionResult,
                        ptenNote: this.ptenNote,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenStatus.text,
                            color: res.data.setPtenStatus.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>

